var _path, _path2, _path3, _path4;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgGoogleIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9931 8.14994C14.9931 7.49443 14.942 7.01608 14.8316 6.52002H7.65039V9.47868H11.8656C11.7806 10.2139 11.3217 11.3212 10.3019 12.0653L10.2876 12.1644L12.5582 13.9978L12.7155 14.0142C14.1602 12.6234 14.9931 10.5771 14.9931 8.14994Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64922 15.9451C9.71433 15.9451 11.448 15.2364 12.7143 14.014L10.3007 12.0651C9.65486 12.5346 8.78799 12.8623 7.64922 12.8623C5.62659 12.8623 3.90991 11.4716 3.29796 9.54932L3.20826 9.55726L0.847282 11.4618L0.816406 11.5513C2.07417 14.1556 4.65772 15.9451 7.64922 15.9451Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29737 9.54936C3.13591 9.0533 3.04246 8.52176 3.04246 7.97257C3.04246 7.42332 3.13591 6.89184 3.28888 6.39577L3.2846 6.29013L0.894048 4.35498L0.815834 4.39376C0.29745 5.47449 0 6.68811 0 7.97257C0 9.25703 0.29745 10.4706 0.815834 11.5513L3.29737 9.54936Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6492 3.08269C9.08542 3.08269 10.0542 3.72934 10.6066 4.26974L12.7653 2.07286C11.4395 0.788397 9.7143 0 7.6492 0C4.65771 0 2.07417 1.78937 0.816406 4.39371L3.28945 6.39573C3.9099 4.47347 5.62657 3.08269 7.6492 3.08269Z",
    fill: "#EB4335"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoogleIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/google-icon.2ff8ae33.svg";
export { ForwardRef as ReactComponent };